module.exports = __webpack_public_path__ + "static/media/informacion-financiera.11287a88.jpg";